import React, { useState, useEffect } from 'react';
import { func } from 'prop-types';
import {
  Backdrop,
  Button,
  Container,
  Fade,
  Modal,
  Paper,
  Typography,
} from '@material-ui/core';

import { withMeetingContext, MeetingContextDevicePermissionsProps } from 'Scenes/_root/meetingContext';
import PermissionStatus from './PermissionStatus';
import PermissionsHelper from './PermissionsHelper';
import styles from './styles.scss';

export const DevicePermissions = ({
  registerMeetingCallbacks,
  devicePermissions,
  onClose,
}) => {
  const [canClose, setCanClose] = useState(false);

  const checkPermissionsAreGranted = () => {
    const { camera, microphone } = devicePermissions.getDevicePermissions();
    if (camera !== 'granted' || microphone !== 'granted') {
      setCanClose(false);
    } else {
      setCanClose(true);
    }
  };

  const handleClose = () => {
    if (canClose) {
      onClose();
    }
  };

  useEffect(() => {
    checkPermissionsAreGranted();
    return registerMeetingCallbacks('devicePermissions', {
      onDevicePermissionChange: checkPermissionsAreGranted,
    });
  }, []);

  return (
    <Modal
      closeAfterTransition
      open
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      className={styles.devicePermissionsModal}
      onClose={handleClose}
    >
      <Fade in>
        <Paper classes={{ root: styles.paper }}>
          <Container classes={{ root: styles.container }} maxWidth="sm">
            <Typography variant='h5'>Device permissions</Typography>
            <Typography variant='body1'>
              It looks like permission is currently not granted to your input devices. TeleConsult requires permission to access your camera and microphone.
            </Typography>
            <PermissionStatus
              permissionName='camera'
            />
            <PermissionStatus
              permissionName='microphone'
            />
            <PermissionsHelper />
            <Button
              fullWidth
              color='primary'
              disabled={!canClose}
              onClick={handleClose}
              type='button'
              variant='contained'
            >
              Done
            </Button>
          </Container>
        </Paper>
      </Fade>
    </Modal>
  );
};

DevicePermissions.propTypes = {
  onClose: func.isRequired,
  registerMeetingCallbacks: func.isRequired,
  devicePermissions: MeetingContextDevicePermissionsProps,
};

export default withMeetingContext(['registerMeetingCallbacks', 'devicePermissions'])(DevicePermissions);
